const column = [
  {
    title: "STT",
    scopedSlots: { customRender: "stt" },
    width: 100,
    align: "center",
  },
  {
    title: "Tên",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
    sorter: (positionA, positionB) => {
      var codeA = positionA.name.toUpperCase();
      var codeB = positionB.name.toUpperCase();
      return codeA.localeCompare(codeB);
    },
  },

  // {
  //   title: "Mô tả",
  //   dataIndex: "description",
  //   scopedSlots: { customRender: "description" },
  //   sorter: (positionA, positionB) => {
  //     var codeA = positionA.name.toUpperCase();
  //     var codeB = positionB.name.toUpperCase();
  //     return codeA.localeCompare(codeB);
  //   },
  // },

  {
    title: "Ngày tạo",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 160,
  },
  {
    title: "Ngày chỉnh sửa",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 160,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 15,
  },
];

export { column };
